import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { compose } from "redux";
import {
  selectGemeindeliste,
  selectGemeindeDataIsLoading,
  selectGemeinde,
} from "../../redux/gemeinde/gemeinde.selector";
import WithSpinner from "../with-spinner/with-spinner.component";
import RanglisteComponent from "./rangliste.component";

const mapStateToProps = createStructuredSelector({
  isLoading: selectGemeindeDataIsLoading,
  gemeindeliste: selectGemeindeliste,
  gemeinde: selectGemeinde,
});

const RanglisteContainer = compose(
  connect(mapStateToProps),
  WithSpinner
)(RanglisteComponent);

export default RanglisteContainer;
